module.exports = __webpack_public_path__ + "media/components/Shared/Slick/nextArrow-6c8fe1dcc9a60e31cb64681447ecc62c.svg";